import * as THREE from 'three';

import { CameraSetup } from '@data';

export function toMatrix4(m: number[][]) {
    return new THREE.Matrix4().set(
        m[0][0],
        m[0][1],
        m[0][2],
        m[0][3],

        m[1][0],
        m[1][1],
        m[1][2],
        m[1][3],

        m[2][0],
        m[2][1],
        m[2][2],
        m[2][3],

        m[3][0],
        m[3][1],
        m[3][2],
        m[3][3],
    );
}
export function getCoverSourceRect(imageWidth: number, imageHeight: number, canvasWidth: number, canvasHeight: number) {
    const canvasAspect = canvasWidth / canvasHeight;
    const imageAspect = imageWidth / imageHeight;

    if (imageAspect > canvasAspect) {
        const sourceWidth = imageHeight * canvasAspect;
        return { sourceX: (imageWidth - sourceWidth) / 2, sourceY: 0, sourceWidth, sourceHeight: imageHeight };
    }

    const sourceHeight = imageWidth / canvasAspect;
    return { sourceX: 0, sourceY: (imageHeight - sourceHeight) / 2, sourceWidth: imageWidth, sourceHeight };
}
export function getCoverAdjustedIntrinsics(config: CameraSetup, canvasWidth: number, canvasHeight: number) {
    const { fx, fy, cx, cy, width: imageWidth, height: imageHeight } = config.intrinsics;
    const sourceRect = getCoverSourceRect(imageWidth, imageHeight, canvasWidth, canvasHeight);
    const scaleX = canvasWidth / sourceRect.sourceWidth;
    const scaleY = canvasHeight / sourceRect.sourceHeight;

    return {
        fx: fx * scaleX,
        fy: fy * scaleY,
        cx: (cx - sourceRect.sourceX) * scaleX,
        cy: (cy - sourceRect.sourceY) * scaleY,
    };
}
